define(
    'viewmodels/secured/explorer/explorer',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "viewmodels/secured/explorer/details/details",
        "viewmodels/secured/explorer/results/results",
        "viewmodels/secured/explorer/navigation/navigation",
        "viewmodels/secured/explorer/navigation/menu",

        "viewmodels/secured/explorer/details/tabs/actions/actions"
    ],
    function (ctx, ViewModel, details, results, navigation, menu) {
        var vm = new ViewModel(
        {
            hasCodeBehind: true,
            isVisible: ko.observable(false)
        });

        vm.activate = function (type, id1, id2, id3, id4) {
            //console.warn(type);
            //console.warn(id1);
            //console.warn(id2);
            //console.warn(id3);
            //console.warn(id4);            

            sessionStorage.__url_type = type;
            
            sessionStorage.__url_libraryId = "";
            sessionStorage.__url_listValueId = "";
            sessionStorage.__url_folderId = "";
            sessionStorage.__url_documentId = "";

            if (sessionStorage.__url_type == "library") {
                sessionStorage.__url_libraryId = id1 ? id1 : "";
                sessionStorage.__url_folderId = id2 ? id2 : "";
                sessionStorage.__url_documentId = id3 ? id3 : "";
            }
            if (sessionStorage.__url_type == "library-list") {
                sessionStorage.__url_libraryId = id1;
                sessionStorage.__url_listValueId = id2 ? id2 : "";
                sessionStorage.__url_folderId = id3 ? id3 : "";
                sessionStorage.__url_documentId = id4 ? id4 : "";
            }
        };

        vm.attached = function () {
        };

        ctx.onNavSearch.subscribe(function (data) {
            init();
        });
        ctx.onNavFavoriteFolder.subscribe(function (data) {
            init();
        });
        ctx.onNavFavoriteSearch.subscribe(function (data) {
            init();
        });
        ctx.onNavFavoriteDocument.subscribe(function (data) {
            init();
        });
        ctx.onNavFlagged.subscribe(function (data) {
            init();
        });
        ctx.onNavRecent.subscribe(function (data) {
            init();
        });
        ctx.onNavAllCheckedOut.subscribe(function (data) {
            init();
        });
        ctx.onNavMyCheckedOut.subscribe(function (data) {
            init();
        });
        ctx.onNavFolder.subscribe(function (data) {
            
        });
        ctx.onNavFolderShowAll.subscribe(function (data) {
            
        });
        ctx.onNavMyDeleted.subscribe(function (data) {
            init();
        });
        ctx.onNavAllDeleted.subscribe(function (data) {
            init();
        });

        return vm;

        function init() {
            if (ctx.current.library) {
                ctx.saveState(ctx.current.library.libraryId, ctx.current);                
            }

            ctx.current = ctx.loadState(null);
        }
});
